module.exports = __webpack_public_path__ + "img/3.94678c8c.png";